import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import AppConfigProvider from "./context/AppConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <StrictMode>
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </AuthProvider>
  </ThemeProvider>
  // </StrictMode>
);
